import { IReportMapAxios } from "../IReportMapAxios";
import { IPolygon } from "../../Models/Models";
import Axios, { AxiosError } from "axios";

export class ReportMapAxios implements IReportMapAxios {
    public GetBlockgroupPolygons(blockGroupIds: string[]): Promise<IPolygon[]> {
        return new Promise<IPolygon[]>((resolve, reject) => {
            Axios.post("/services/mapping/geography/BlockGroups", {
                blockGroupIds: blockGroupIds,
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error: AxiosError) => {
                    reject(error.message);
                });
        });
    }
}
